export default window.location.protocol +'//'+ window.location.hostname;